var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating123(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 33.75C5.82663 33.75 5.54048 33.6315 5.32951 33.4205C5.11853 33.2095 5 32.9234 5 32.625V4.79039C5.00008 4.49563 5.07737 4.20603 5.22417 3.95042C5.37097 3.69482 5.58216 3.48212 5.83672 3.33352C6.6875 2.83922 8.40172 2.25 11.75 2.25C14.3663 2.25 17.2927 3.2843 19.8746 4.19625C21.9537 4.93102 23.9176 5.625 25.25 5.625C26.9652 5.61974 28.6622 5.27316 30.2422 4.60547C30.4346 4.52426 30.6441 4.49191 30.852 4.51132C31.0599 4.53074 31.2598 4.6013 31.4339 4.71672C31.6079 4.83214 31.7507 4.98884 31.8495 5.17284C31.9483 5.35683 32 5.56242 32 5.77125V21.195C31.9997 21.4684 31.9198 21.7358 31.7699 21.9644C31.6201 22.1931 31.4068 22.3731 31.1562 22.4824C30.5438 22.7503 28.3079 23.625 25.25 23.625C23.5527 23.625 21.4264 23.123 19.1757 22.5907C16.6459 21.993 14.0302 21.375 11.75 21.375C9.15758 21.375 7.83078 21.7673 7.25 22.0155V32.625C7.25 32.9234 7.13147 33.2095 6.92049 33.4205C6.70952 33.6315 6.42337 33.75 6.125 33.75Z",
    fill: "#0CB189"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating123);
export default __webpack_public_path__ + "static/media/rating (1) 2 (3).a658aa498d28f7ba2bf539794f27ba49.svg";
export { ForwardRef as ReactComponent };